import React, { useEffect, useState } from "react"
import { Button, Col, Row } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { BundleCompositionFormProps } from "../../../common/types/bundle"
import IntlProps from "../../../state/helpers/IntlProps"
import { ProductItemDto } from "../../../state/listing/product/models"
import { addBundleItem } from "../../../state/product/ProductActions"
import { getBundleItems } from "../../../state/product/ProductSelectors"
import { PRODUCT_TYPE } from "../../../state/product/Types"
import { mapProductItemToBundleItem } from "../../../utils/bundle"
import { bundleCompositionMessages } from "../../../utils/bundle/constants"
import ProductSearchModal from "../../components/ProductSearchModal"
import BundleItemsListComponent from "../components/BundleItemsListComponent"
import EmptyProductBundleComponent from "../components/EmptyProductBundleComponent"

const BundleCompositionForm = (props: BundleCompositionFormProps & IntlProps) => {
    const [modal, setModal] = useState<JSX.Element[]>()
    const [onShowModal, setOnShowModal] = useState(false)
    const dispatch = useDispatch()
    const bundleItems = useSelector(state => getBundleItems(state))

    const handleModal = () => {
        setOnShowModal(!onShowModal)
    }

    const handleAddBundleItem = (item: ProductItemDto) => {
        dispatch(addBundleItem(mapProductItemToBundleItem(item)))
    }

    useEffect(() => {
        if (onShowModal) {
            const modal = [] as JSX.Element[]
            modal.push(<ProductSearchModal
                onShowModal={onShowModal}
                isModalChangedCallback={handleModal}
                productType={[PRODUCT_TYPE.SINGLE, PRODUCT_TYPE.ASSEMBLY, PRODUCT_TYPE.MATRIX_PARENT]}
                addItemCallback={handleAddBundleItem}
                infoMessage={props.intl.formatMessage(bundleCompositionMessages["product.bundle.forms.bundle_composition_form.modal_message"])}
            />)
            setModal(modal)
        } else {
            const modal = [] as JSX.Element[]
            setModal(modal)
        }
    }, [onShowModal])

    return (
        <div>
            {modal}
            <div>
                <Row>
                    <Col>
                        <h4 className="custom-lead">
                            <FormattedMessage
                                id="product.bundles.forms.bundle_composition_form.title"
                                defaultMessage="Bundle Composition"
                            />
                        </h4>
                    </Col>
                    <Col className="text-right">
                        {bundleItems.length === 0 
                            ? <small><div className="text-danger">{props.errors}</div></small>
                            : <Button type="button" className="btn btn-primary" onClick={handleModal}>
                                <FormattedMessage
                                    id="product.bundles.forms.bundle_composition_form.add_items"
                                    defaultMessage="Add new items" />
                            </Button>
                        }
                    </Col>
                </Row>
                {bundleItems.length === 0 ?
                    <Row className="row mt-5">
                        <Col>
                            <div className="d-flex align-items-center justify-content-center my-2">
                                <Button type="button" className="btn btn-primary" onClick={handleModal}>
                                    <FormattedMessage
                                        id="product.bundles.forms.bundle_composition_form.add_items"
                                        defaultMessage="Add new items" />
                                </Button>
                            </div>
                            <div>
                                <EmptyProductBundleComponent />
                            </div>
                        </Col>
                    </Row>
                    : <div>
                        <Row className="mt-4">
                            <Col>
                                <p className="h6">
                                    <FormattedMessage
                                        id="product.bundles.forms.bundle_composition_form.items_added"
                                        defaultMessage="Items Added:" />
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <BundleItemsListComponent />
                            </Col>
                        </Row>
                    </div>
                }
            </div>
        </div>
    )
}

export default injectIntl(BundleCompositionForm)


// WEBPACK FOOTER //
// ./src/product/bundle/forms/BundleCompositionForm.tsx